module.exports = __webpack_public_path__ + "static/media/carousel_logo.4909e975.png";